const env = import.meta.env as Record<string, string | undefined>;

function firstConfigured(...values: Array<string | undefined>) {
	return values.find((value) => typeof value === 'string' && value.trim())?.trim();
}

function uniqueContracts(values: Array<string | undefined>) {
	const seen = new Set<string>();
	return values
		.map((value) => value?.trim())
		.filter((value): value is string => Boolean(value))
		.filter((value) => {
			const key = value.toLowerCase();
			if (seen.has(key)) return false;
			seen.add(key);
			return true;
		});
}

export const WATCHER_GAME_ID_CONTRACT_ADDRESS =
	firstConfigured(
		env.VITE_CURRENT_GAME_ID_CONTRACT_ADDRESS,
		env.VITE_NEXT_PUBLIC_GAME_ID_CONTRACT_ADDRESS,
		env.NEXT_PUBLIC_GAME_ID_CONTRACT_ADDRESS
	) || '0x7A48813f3c5C397B8C108DbD46D8466f7BBD4Abd';

export const WATCHER_LEGACY_GAME_ID_CONTRACT_ADDRESS =
	firstConfigured(
		env.VITE_LEGACY_GAME_ID_CONTRACT_ADDRESS,
		env.VITE_GAME_ID_LEGACY_CONTRACT_ADDRESS,
		env.VITE_GAME_ID_CONTRACT_ADDRESS,
		env.GAME_ID_CONTRACT_ADDRESS
	) || '0x342884D2Cb5b7D492a8f411959358cD3242CC6D8';

export const WATCHER_BUILDER_CONTRACT_ADDRESS =
	firstConfigured(
		env.VITE_WATCHER_BUILDER_CONTRACT_ADDRESS,
		env.VITE_NEXT_PUBLIC_WATCHER_BUILDER_CONTRACT_ADDRESS,
		env.NEXT_PUBLIC_WATCHER_BUILDER_CONTRACT_ADDRESS
	) || '0x9fe03881CD12E399E977A70b038805e752E0961b';

export const WATCHER_PLAYER_CONTRACT_ADDRESS =
	firstConfigured(
		env.VITE_WATCHER_PLAYER_CONTRACT_ADDRESS,
		env.VITE_NEXT_PUBLIC_WATCHER_PLAYER_CONTRACT_ADDRESS,
		env.NEXT_PUBLIC_WATCHER_PLAYER_CONTRACT_ADDRESS
	) || '0x81d1c6cb722a16796551c9bc84c9486cd991884e';

export const WATCHER_ACCESS_PASS_CONTRACT_ADDRESSES = uniqueContracts([
	env.VITE_WATCHER_FOUNDER_PASS_CONTRACT_ADDR,
	env.VITE_WATCHER_FOUNDER_PASS_CONTRACT_ADDRESS,
	env.VITE_NEXT_PUBLIC_WATCHER_FOUNDER_PASS_CONTRACT_ADDRESS,
	env.NEXT_PUBLIC_WATCHER_FOUNDER_PASS_CONTRACT_ADDRESS,
	env.WATCHER_FOUNDER_PASS_CONTRACT_ADDR,
	'0xb752d9870eE15ED21a16277D2869910dAE11D7D2',
	'0xB15540cdec340283150ECa0C41E91CEb214fa30E',
	env.VITE_WATCHER_FOUNDER_TEST_PASS_CONTRACT_ADDR,
	env.VITE_WATCHER_FOUNDER_TEST_PASS_CONTRACT_ADDRESS,
	env.VITE_NEXT_PUBLIC_WATCHER_FOUNDER_TEST_PASS_CONTRACT_ADDRESS,
	env.NEXT_PUBLIC_WATCHER_FOUNDER_TEST_PASS_CONTRACT_ADDRESS,
	env.WATCHER_FOUNDER_TEST_PASS_CONTRACT_ADDR,
	'0xF42a12Ed215d0D7a36123340a516D78A6C9D39dA',
]);

export const WATCHER_FOUNDER_PASS_CONTRACT_ADDRESS =
	WATCHER_ACCESS_PASS_CONTRACT_ADDRESSES[0] ||
	'0xb752d9870eE15ED21a16277D2869910dAE11D7D2';

export const WATCHER_ORACLE_EDITION_CONTRACT_ADDRESS =
	firstConfigured(
		env.VITE_ACCESS_PASS_ORACLE_EDITION,
		env.VITE_NEXT_PUBLIC_ACCESS_PASS_ORACLE_EDITION,
		env.NEXT_PUBLIC_ACCESS_PASS_ORACLE_EDITION
	) || '0x3A337572c5536006AEb5B97Ed6A5075aa6DDF1Ac';

export const BASE_WKRM_ADDRESS =
	firstConfigured(
		env.VITE_BASE_WKRM_ADDRESS,
		env.VITE_NEXT_PUBLIC_BASE_WKRM_ADDRESS,
		env.NEXT_PUBLIC_BASE_WKRM_ADDRESS,
		env.VITE_KARMA_TOKEN_ADDRESS
	) || '0x0910B5224D0d89f58885d0AeB20D56D1870127CF';
